export default "__VITE_ASSET__ByeM5MA7__"